import { BannerType } from '@/app/entities/Banner'
import { Button } from '@/view/components/ui/button'
import { AddCircle } from 'iconsax-react'
import { getCardSize } from './utils'
import { Dialog, DialogContent } from '@/view/components/ui/dialog'

import { BannerForm } from './BannerForm'
import { useState } from 'react'

interface AddBannerButtonProps {
  type: BannerType
}

export const AddBannerButton = ({ type }: AddBannerButtonProps) => {
  const size = getCardSize(type)
  const [isOpen, setIsOpen] = useState(false)
  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <>
      <Button
        onClick={openModal}
        style={{
          width: size.width,
          height: size.height,
          flexShrink: 0,
        }}
        variant="outline"
        className="flex flex-col items-center gap-2 rounded-xl border-solid border-gray-300"
      >
        <AddCircle className="h-8 w-8" />
        <span className="text-sm">Adicionar Banner</span>
      </Button>
      <Dialog open={isOpen} onOpenChange={closeModal}>
        <DialogContent className="w-max min-w-fit max-w-none">
          <BannerForm type={type} onSuccess={closeModal} />
        </DialogContent>
      </Dialog>
    </>
  )
}
